import { SeasonsComponent } from './user-content/seasons/seasons.component';
import { RafflesComponent } from './user-content/raffles/raffles.component';
import {Route} from '@angular/router';
import {OperationsLogComponent} from "./user-content/operations-log/operations-log.component";
import {CommonStatsComponent} from "./user-content/common-stats/common-stats.component";
import {WithdrawComponent} from "./user-content/withdraw/withdraw.component";
import {SearchUserComponent} from "./search-user.component";
import {UserContentComponent} from "./user-content/user-content.component";
import {CheckIpComponent} from "./check/check-ip/check-ip.component";
import {CheckWalletComponent} from "./check/check-wallet/check-wallet.component";
import {FindComponent} from "./find/find.component";
import {ReferralCampaignsComponent} from "./user-content/referral-campaigns/referral-campaigns.component";
import {UserInventoryComponent} from "./user-content/user-inventory/user-inventory.component";
import {CashbackHistoryComponent} from "./user-content/cashback-history/cashback-history.component";
import {XpHistoryComponent} from "./user-content/xp-history/xp-history.component";
import {RefIncomeLogComponent} from "./user-content/referral-campaigns/ref-income-log/ref-income-log.component";
import {MarketComponent} from "./user-content/market/market.component";
import {BidsComponent} from "./user-content/market/bids/bids.component";
import {SteamInventoryComponent} from "./user-content/market/steam-inventory/steam-inventory.component";
import {RefillItemsComponent} from "./user-content/market/refill-items/refill-items.component";
import {FreeCasesComponent} from "./user-content/free-cases/free-cases.component";
import {RefillComponent} from "./user-content/refill/refill.component";
import {RestrictionsComponent} from "./user-content/restrictions/restrictions.component";
import {WelcomeCasesComponent} from "./user-content/welcome-cases/welcome-cases.component";
import {BalanceHistoryComponent} from "./user-content/balance-history/balance-history.component";
import {PromoCodesHistoryComponent} from "./user-content/promo-codes-history/promo-codes-history.component";
import {PaybacksComponent} from "./user-content/paybacks/paybacks.component";
import {VipComponent} from "./user-content/vip/vip.component";
import {RoleGuardService} from "../../@core/guards/role-guard.service";
import {VIP_USER_SECTION_ROLES} from "../../@shared/constants/vip-access";
import {UserCustomizationComponent} from './user-content/customization/user-customization.component';
import {ContactsComponent} from './user-content/contacts/contacts.component';

export const searchUserRoutes: Route[] = [
  {
    path: '',
    component: SearchUserComponent,
    children: [
      {
        path: 'find',
        component: FindComponent,
      },
      {
        path: ':id',
        component: UserContentComponent,
        children: [
          {
            path: '',
            redirectTo: 'main',
            pathMatch: 'full',
          },
          {
            path: 'main',
            component: CommonStatsComponent
          },
          {
            path: 'customization',
            component: UserCustomizationComponent
          },
          {
            path: 'user-inventory',
            component: UserInventoryComponent
          },
          {
            path: 'market',
            component: MarketComponent,
            children: [
              {
                path: '',
                redirectTo: 'steam-inventory',
                pathMatch: 'full',
              },
              {
                path: 'steam-inventory',
                component: SteamInventoryComponent
              },
              {
                path: 'refill-items',
                component: RefillItemsComponent
              },
              {
                path: 'bids',
                component: BidsComponent
              },
            ]
          },
          {
            path: 'referral-campaigns',
            component: ReferralCampaignsComponent,
          },
          {
            path: 'paybacks',
            component: PaybacksComponent,
          },
          {
            path: 'ref-income-log',
            component: RefIncomeLogComponent
          },
          {
            path: 'transactions-history',
            component: OperationsLogComponent,
          },
          {
            path: 'balance-history',
            component: BalanceHistoryComponent,
          },
          { path: 'seasons', component: SeasonsComponent },
          {
            path: 'raffles',
            component: RafflesComponent
          },
          {
            path: 'promo-codes-history',
            component: PromoCodesHistoryComponent,
          },
          {
            path: 'withdraw',
            component: WithdrawComponent,
          },
          {
            path: 'refill',
            component: RefillComponent
          },
          {
            path: 'contacts',
            component: ContactsComponent
          },
          {
            path: 'restrictions',
            component: RestrictionsComponent
          },
          {
            path: 'cashback-history',
            component: CashbackHistoryComponent,
          },
          {
            path: 'xp-history',
            component: XpHistoryComponent,
          },
          {
            path: 'free-cases',
            component: FreeCasesComponent
          },
          {
            path: 'check/ip/:ip',
            component: CheckIpComponent
          },
          {
            path: 'welcome-cases',
            component: WelcomeCasesComponent
          },
          {
            path: 'vip',
            component: VipComponent,
            canActivate: [RoleGuardService],
            data: { roles: VIP_USER_SECTION_ROLES }
          }
        ]
      },
      {
        path: 'check/ip/:ip',
        component: CheckIpComponent
      },
      {
        path: 'check/wallet/:wallet',
        component: CheckWalletComponent
      },
      {
        path: '**',
        redirectTo: '/'
      }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
